import {Component} from '@angular/core';
import {UiService} from './common/state/ui.service';
import {RouterOutlet} from '@angular/router';

@Component({
    selector: 'rtapp-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet]
})
export class AppComponent {

    constructor(public uiService: UiService) {
    }


}
